import React from 'react';
import IframeWidget from "../../utils/IframeWidget";
import {ReactComponent as TriangleErrorIco} from "../../../images/icons/triangle-error.svg";
import {useTranslation} from "react-i18next";
import PopupModal from "./PopupModal";

interface Props {
    show: boolean;
    onHide: () => void;
}

const TemporarilyClosedInfoModal = ({show, onHide}: Props) => {
    const {t} = useTranslation();

    const handleOnHide = () => {
        IframeWidget.onHide(onHide);
    }

    return <PopupModal
        bodyContent={<></>}
        headerIcon={<TriangleErrorIco/>}
        headerIconClassName="text-warning"
        title={t("modules.temporarily_closed_modal.header.title")}
        show={show}
        onHide={handleOnHide}
        description={t("modules.temporarily_closed_modal.field.cannot_place_orders.title")}
        primaryButton={<button className={"btn btn-default w-100"} onClick={handleOnHide}>
            {t("modules.temporarily_closed_modal.action.understand.title")}
        </button>}
    />
}

export default TemporarilyClosedInfoModal;